<template>
  <div class="o-fair__detail">
    <bos-loader v-if="isLoading" minHeight />

    <template v-else-if="this.booth !== undefined && this.booth !== null">
      <modal :id="modalId" variant="iframe" :iframeUrl="teamUrl"></modal>
      <fair-header
        :fair="fair"
        :boothId="$route.params.booth"
        :boothAddress="boothAddress"
        :boothCorrespondenceAddress="boothCorrespondenceAddress"
        :shops="booth.shopzugaenge"
        v-if="
          (booth !== null && JSON.stringify(booth) !== JSON.stringify({})) ||
            this.$route.params.booth === 'new'
        "
        :boothdata="booth"
      />
      <template v-if="$options.name === $route.name">
        <marketing-teaser
          :teaserType="2"
          :fair="fair._id"
          @loaded="teaserLoaded"
          :tasksDone="fairTasksDone"
          :booth-state="flowState()"
          :boothId="$route.params.booth"
        />
        <marketing-teaser
          :teaserType="4"
          :fair="fair._id"
          @loaded="teaserLoaded"
          :tasksDone="fairTasksDone"
          :booth-state="flowState()"
          :boothId="$route.params.booth"
        />

        <tabs
          ref="tabs"
          class="bos-tabs"
          v-if="this.booth !== null"
          :options="{
            useUrlFragment: false,
            defaultTabHash: isNewBooth() ? 'tab-info' : ''
          }"
        >
          <tab :name="$t('fair.tabs.statusflow.title')" id="tab-statusflow">
            <p v-html="flowText()"></p>
            <div class="header-action header-action2" v-if="!isNewBooth() && hasRegistrationLink">
              <bos-button @click.prevent="openRegistrationUrl" bigicon>{{
                $t('fair.header.action.addStandCoexposant')
                }}
                <template #icon><svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
                  <path class="cls-1" d="M523.39,611.91c137.71,0,215.87-86.61,215.87-193.44s-78.18-193.44-215.87-193.44-215.87,86.61-215.87,193.44,78.16,193.44,215.87,193.44Z"/>
                  <path class="cls-1" d="M743.99,698.07c-64.41-9.11-128.84-8.94-191.16-8.66l-29.64.07-29.06-.08c-62.45-.29-126.96-.52-191.37,8.86-153.56,22.34-252.77,131.55-252.77,278.23v298.48h148.7v-314.85h67.69v314.85h517.06v-314.85h67.69v314.85h147.01v-298.48c0-147.31-99.76-256.59-254.14-278.41Z"/>
                  <path class="cls-1" d="M1371.92,303.12c-50.35-50.35-117.3-78.08-188.51-78.08s-138.16,27.73-188.51,78.08c-50.35,50.35-78.08,117.3-78.08,188.51s27.73,138.16,78.08,188.51c50.35,50.35,117.3,78.08,188.51,78.08s138.16-27.73,188.51-78.08c50.35-50.35,78.08-117.3,78.08-188.51s-27.73-138.16-78.08-188.51ZM1370.17,534.16h-140.8v112.64h-91.95v-112.64h-140.8v-87.93h140.8v-109.76h91.95v109.76h140.8v87.93Z"/>
                </svg></template>
                </bos-button>
            </div>
            <div class="header-action" v-if="isNewBooth() && this.fair.registrationDeadline !== undefined && this.fair.registrationDeadline !== null && new Date(this.fair.registrationDeadline).getTime() > new Date().getTime() && (hasGastroLink || hasDefaultGastroLink)">
              <bos-button @click.prevent="openGastroRegistrationUrl" bigicon v-if="hasGastroLink">{{
                $t('fair.header.action.orderNowGastro')
                }}
                <template #icon><svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
                  <path class="cls-1" d="M425.11,713.69s.04.05.06.07c.03.03.07.06.1.09l1.3,1.23c.16.15.37.2.54.35,3.24,2.62,7.68,4.73,14.55,4.73,12.69,0,33.45-7.12,69.24-31.26,38.53-25.97,84.77-65.3,130.2-110.73,7.14-7.14,173.26-174.19,136.18-215.18-.2-.23-.28-.53-.51-.75l-3.12-3.06c-82.74-82.75-195.72-87.81-293.08-17.59-20.37-16.17-47.84-13.55-68.76,7.37-20.91,20.91-23.55,48.36-7.38,68.74-30.58,42.4-47.11,88.26-48.24,134.81-1.42,58.19,21.97,114.4,66.06,158.48l2.85,2.7ZM426.64,363.77c11.63-11.64,25.15-14.48,36.46-8.54-7.98,6.64-15.85,13.75-23.54,21.45-7.68,7.68-14.8,15.55-21.45,23.54-5.93-11.3-3.09-24.82,8.54-36.45ZM377.14,553.01c1.38-56.54,28.09-112.39,77.22-161.53,90.4-90.4,203.77-102.12,288.39-32.15-63.34,20.43-176.16,132.64-181.99,138.47-45.43,45.43-84.76,91.67-110.73,130.21-15.3,22.7-23.73,39.32-27.87,51.71-30.25-36.92-46.12-81.19-45.01-126.7Z"/>
                  <rect class="cls-1" x="661.72" y="463.75" width="388.02" height="20.94" transform="translate(-11.26 927.52) rotate(-56.6)"/>
                  <rect class="cls-1" x="736.34" y="530.55" width="386.31" height="20.95" transform="translate(-132.84 708.7) rotate(-39.17)"/>
                  <path class="cls-1" d="M648.69,936.78c0,13.91,3.61,24.2,11.04,31.47,14.13,13.83,38.67,13.33,72.66,12.56,17.12-.36,38.36-.36,55.49,0,7.31.16,14.19.31,20.62.31,23.58,0,41.19-2,52.34-12.92,7.43-7.27,11.04-17.54,11.04-31.42,0-50.55-45.89-85.84-111.59-85.84s-111.59,35.3-111.59,85.84ZM850.16,927.82c-6.29,7.14-13.93,4.82-35.15-5.15-2.55-1.2-5.25-2.45-8-3.69l21.02-27.52c12.12,9.39,19.88,21.78,22.13,36.37ZM770.75,872.23c14.68.96,27.77,3.99,38.97,8.69l-23.07,30.2c-5.09-1.56-10.4-2.78-15.91-3.51v-35.37ZM806.1,941.62c12.7,5.97,27.3,12.8,40.76,10.88-.27.3-.51.55-.68.72-7.88,7.72-29.9,7.24-57.84,6.64-17.41-.38-39-.38-56.4,0-27.33.6-48.99,1.03-57.13-6.29,1.86.23,3.7.39,5.49.39,13.86,0,26.01-6.48,37.21-12.45,12.68-6.76,25.78-13.75,42.77-13.75s32.01,7.36,45.83,13.85ZM749.81,872.23v35.34c-5.53.72-10.7,1.94-15.54,3.5l-23.13-30.27c11.13-4.63,24.12-7.62,38.67-8.57ZM692.76,891.26l21.6,28.27c-2.31,1.19-4.57,2.37-6.71,3.51-16.24,8.65-25.59,13.02-37.66,7.7,1.63-15.96,9.71-29.44,22.77-39.48Z"/>
                  <path class="cls-1" d="M664.83,698.38l-23.34-18.78-27.05,22.41-24.77-1.46-16.56,37.57h0s-.82,1.87-.82,1.87v81.09c0,22.38,27.2,36.84,69.3,36.84s69.31-14.47,69.31-36.84v-81.4l-21.2-41.51-24.86.21ZM623.94,833.23h-20.95v-53.23h20.95v53.23ZM641.59,758.09c-31.28,0-45.81-8.67-48.04-14.39l9.43-21.39,18.47,1.09,20.24-16.76,15.85,12.76,19.4-.16,12.62,24.69c-2.53,5.72-17.09,14.17-47.96,14.17Z"/>
                  <path class="cls-1" d="M539.97,795.23l9.18-5.05-10.1-18.35-9.17,5.06c-53.36,29.38-82.75,68.2-82.75,109.32,0,89.44,135.52,159.5,308.53,159.5s308.52-70.06,308.52-159.5c0-31.57-17.26-61.91-49.91-87.73l-8.21-6.5-12.99,16.43,8.21,6.5c27.45,21.71,41.96,46.36,41.96,71.3,0,75.11-131.69,138.56-287.58,138.56s-287.59-63.45-287.59-138.56c0-33.13,25.54-65.44,71.9-90.97Z"/>
                  <path class="cls-1" d="M777.57,748.05l10.46.39.79-20.93-10.46-.39c-11.67-.45-23.65-.52-35.38-.29l-10.47.21.42,20.94,10.46-.2c11.36-.22,22.92-.14,34.18.28Z"/>
                  <path class="cls-1" d="M944.55,746.04l-9.13-27.09-28.79-19.67-24.94,10.35-24.92,5.64-18.07,16.18-24.17,9.84-20.88,26.71-4.7,28.2,13,29.7,24.26,13.2,48.57,28.53,21.88,15.64,26.96,11.05,43.14-7.83,11.51-39.38-14.69-34.82,3.46-39.94-22.49-26.3ZM950.28,868.19l-24.5,4.44-17.97-7.14-13.75-9.83,8.7-51.51-57.08-26.59-6.59,44.82-2.53-1.49-18.29-9.97-7.63-17.43,2.8-16.8,14.15-18.11,22.37-9.11,16.73-14.99,20.5-4.64,16.99-6.88,13.64,9.31,8.18,24.29,19.42,22.7-3.15,36.38,13.83,32.73-5.8,19.81Z"/>
                  <polygon class="cls-1" points="1449.72 883.71 1149 764.14 1149 804.26 1393.39 901.43 748.81 1169.88 106.57 901.46 351 804.27 351 764.15 50.31 883.71 50 918.22 741.6 1207.28 755.96 1207.3 1450 918.24 1449.72 883.71"/>
                </svg></template>
              </bos-button>
              <bos-button @click.prevent="openNewGastroRegistrationUrl" bigicon v-else>{{
                $t('fair.header.action.orderNowGastro')
                }}
                <template #icon><svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
                  <path class="cls-1" d="M425.11,713.69s.04.05.06.07c.03.03.07.06.1.09l1.3,1.23c.16.15.37.2.54.35,3.24,2.62,7.68,4.73,14.55,4.73,12.69,0,33.45-7.12,69.24-31.26,38.53-25.97,84.77-65.3,130.2-110.73,7.14-7.14,173.26-174.19,136.18-215.18-.2-.23-.28-.53-.51-.75l-3.12-3.06c-82.74-82.75-195.72-87.81-293.08-17.59-20.37-16.17-47.84-13.55-68.76,7.37-20.91,20.91-23.55,48.36-7.38,68.74-30.58,42.4-47.11,88.26-48.24,134.81-1.42,58.19,21.97,114.4,66.06,158.48l2.85,2.7ZM426.64,363.77c11.63-11.64,25.15-14.48,36.46-8.54-7.98,6.64-15.85,13.75-23.54,21.45-7.68,7.68-14.8,15.55-21.45,23.54-5.93-11.3-3.09-24.82,8.54-36.45ZM377.14,553.01c1.38-56.54,28.09-112.39,77.22-161.53,90.4-90.4,203.77-102.12,288.39-32.15-63.34,20.43-176.16,132.64-181.99,138.47-45.43,45.43-84.76,91.67-110.73,130.21-15.3,22.7-23.73,39.32-27.87,51.71-30.25-36.92-46.12-81.19-45.01-126.7Z"/>
                  <rect class="cls-1" x="661.72" y="463.75" width="388.02" height="20.94" transform="translate(-11.26 927.52) rotate(-56.6)"/>
                  <rect class="cls-1" x="736.34" y="530.55" width="386.31" height="20.95" transform="translate(-132.84 708.7) rotate(-39.17)"/>
                  <path class="cls-1" d="M648.69,936.78c0,13.91,3.61,24.2,11.04,31.47,14.13,13.83,38.67,13.33,72.66,12.56,17.12-.36,38.36-.36,55.49,0,7.31.16,14.19.31,20.62.31,23.58,0,41.19-2,52.34-12.92,7.43-7.27,11.04-17.54,11.04-31.42,0-50.55-45.89-85.84-111.59-85.84s-111.59,35.3-111.59,85.84ZM850.16,927.82c-6.29,7.14-13.93,4.82-35.15-5.15-2.55-1.2-5.25-2.45-8-3.69l21.02-27.52c12.12,9.39,19.88,21.78,22.13,36.37ZM770.75,872.23c14.68.96,27.77,3.99,38.97,8.69l-23.07,30.2c-5.09-1.56-10.4-2.78-15.91-3.51v-35.37ZM806.1,941.62c12.7,5.97,27.3,12.8,40.76,10.88-.27.3-.51.55-.68.72-7.88,7.72-29.9,7.24-57.84,6.64-17.41-.38-39-.38-56.4,0-27.33.6-48.99,1.03-57.13-6.29,1.86.23,3.7.39,5.49.39,13.86,0,26.01-6.48,37.21-12.45,12.68-6.76,25.78-13.75,42.77-13.75s32.01,7.36,45.83,13.85ZM749.81,872.23v35.34c-5.53.72-10.7,1.94-15.54,3.5l-23.13-30.27c11.13-4.63,24.12-7.62,38.67-8.57ZM692.76,891.26l21.6,28.27c-2.31,1.19-4.57,2.37-6.71,3.51-16.24,8.65-25.59,13.02-37.66,7.7,1.63-15.96,9.71-29.44,22.77-39.48Z"/>
                  <path class="cls-1" d="M664.83,698.38l-23.34-18.78-27.05,22.41-24.77-1.46-16.56,37.57h0s-.82,1.87-.82,1.87v81.09c0,22.38,27.2,36.84,69.3,36.84s69.31-14.47,69.31-36.84v-81.4l-21.2-41.51-24.86.21ZM623.94,833.23h-20.95v-53.23h20.95v53.23ZM641.59,758.09c-31.28,0-45.81-8.67-48.04-14.39l9.43-21.39,18.47,1.09,20.24-16.76,15.85,12.76,19.4-.16,12.62,24.69c-2.53,5.72-17.09,14.17-47.96,14.17Z"/>
                  <path class="cls-1" d="M539.97,795.23l9.18-5.05-10.1-18.35-9.17,5.06c-53.36,29.38-82.75,68.2-82.75,109.32,0,89.44,135.52,159.5,308.53,159.5s308.52-70.06,308.52-159.5c0-31.57-17.26-61.91-49.91-87.73l-8.21-6.5-12.99,16.43,8.21,6.5c27.45,21.71,41.96,46.36,41.96,71.3,0,75.11-131.69,138.56-287.58,138.56s-287.59-63.45-287.59-138.56c0-33.13,25.54-65.44,71.9-90.97Z"/>
                  <path class="cls-1" d="M777.57,748.05l10.46.39.79-20.93-10.46-.39c-11.67-.45-23.65-.52-35.38-.29l-10.47.21.42,20.94,10.46-.2c11.36-.22,22.92-.14,34.18.28Z"/>
                  <path class="cls-1" d="M944.55,746.04l-9.13-27.09-28.79-19.67-24.94,10.35-24.92,5.64-18.07,16.18-24.17,9.84-20.88,26.71-4.7,28.2,13,29.7,24.26,13.2,48.57,28.53,21.88,15.64,26.96,11.05,43.14-7.83,11.51-39.38-14.69-34.82,3.46-39.94-22.49-26.3ZM950.28,868.19l-24.5,4.44-17.97-7.14-13.75-9.83,8.7-51.51-57.08-26.59-6.59,44.82-2.53-1.49-18.29-9.97-7.63-17.43,2.8-16.8,14.15-18.11,22.37-9.11,16.73-14.99,20.5-4.64,16.99-6.88,13.64,9.31,8.18,24.29,19.42,22.7-3.15,36.38,13.83,32.73-5.8,19.81Z"/>
                  <polygon class="cls-1" points="1449.72 883.71 1149 764.14 1149 804.26 1393.39 901.43 748.81 1169.88 106.57 901.46 351 804.27 351 764.15 50.31 883.71 50 918.22 741.6 1207.28 755.96 1207.3 1450 918.24 1449.72 883.71"/>
                </svg></template>
              </bos-button>
            </div>
            <div class="header-action" v-if="isNewBooth()">
              <bos-button @click.prevent="openNewBoothRegistrationUrl" :color="isNewBooth() && this.fair.registrationDeadline !== undefined && this.fair.registrationDeadline !== null && new Date(this.fair.registrationDeadline).getTime() > new Date().getTime() && hasGastroLink ? 'ghost' : ''" bigicon>{{
                $t('fair.header.action.orderNow')
              }}
            <template #icon><svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
              <path class="cls-1" d="M1449.72,779l-301.19-119.75v-110.81l-379.88-151.03v206.12l102.02,40.56-120.67,47.97-120.65-47.97,102.01-40.56v-206.12l-379.87,151.03v110.81l-301.19,119.75-.31,34.52,691.6,289.06h14.36s694.04-289.04,694.04-289.04l-.28-34.53ZM768.65,724.77l342.6-136.21v187.49l-342.6,136.22v-187.51ZM388.78,588.57l342.58,136.21v187.51l-342.58-136.22v-187.49ZM748.81,1065.18L106.57,796.76l244.93-97.39v102l398.51,158.43,398.52-158.43v-102l244.86,97.36-644.58,268.45Z"/>
            </svg>
            </template>
            </bos-button>
            </div>
            <div class="header-action" v-if="!isNewBooth() && this.fair.registrationDeadline !== undefined && this.fair.registrationDeadline !== null && new Date(this.fair.registrationDeadline).getTime() > new Date().getTime()">
              <bos-button @click.prevent="openNewBoothRegistrationUrl" color="ghost" bigicon>
                {{
                  $t('fair.header.action.addStand')
                }}
                <template #icon><svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
                  <path class="cls-1" d="M1111,681.41c73.39,0,142.39-28.58,194.28-80.47,51.89-51.89,80.47-120.89,80.47-194.28s-28.58-142.39-80.47-194.28c-51.9-51.89-120.89-80.47-194.28-80.47s-142.39,28.58-194.28,80.47c-51.89,51.89-80.47,120.89-80.47,194.28s28.58,142.39,80.47,194.28c51.9,51.89,120.89,80.47,194.28,80.47ZM918.51,359.86h145.11v-113.12h94.76v113.12h145.11v90.62h-145.11v116.09h-94.76v-116.09h-145.11v-90.62Z"/>
                  <path class="cls-1" d="M1449.72,1044.52l-301.19-119.75v-110.81l-379.88-151.03v206.12l102.02,40.56-120.67,47.97-120.65-47.97,102.01-40.56v-206.12l-379.87,151.03v110.81l-301.19,119.75-.31,34.52,691.6,289.06h14.36s694.04-289.04,694.04-289.04l-.28-34.53ZM768.65,990.29l342.6-136.21v187.49l-342.6,136.22v-187.51ZM388.78,854.08l342.58,136.21v187.51l-342.58-136.22v-187.49ZM748.81,1330.69L106.57,1062.27l244.93-97.39v102l398.51,158.43,398.52-158.43v-102l244.86,97.36-644.58,268.45Z"/>
                </svg></template>
              </bos-button>
            </div>
            <div class="header-action" v-if="!isNewBooth() && (hasGastroLink || hasDefaultGastroLink)">
              <bos-button @click.prevent="openGastroRegistrationUrl" color="ghost" bigicon v-if="hasGastroLink">{{
                $t('fair.header.action.orderNowGastro')
                }}
                <template #icon><svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
                  <path class="cls-1" d="M425.11,713.69s.04.05.06.07c.03.03.07.06.1.09l1.3,1.23c.16.15.37.2.54.35,3.24,2.62,7.68,4.73,14.55,4.73,12.69,0,33.45-7.12,69.24-31.26,38.53-25.97,84.77-65.3,130.2-110.73,7.14-7.14,173.26-174.19,136.18-215.18-.2-.23-.28-.53-.51-.75l-3.12-3.06c-82.74-82.75-195.72-87.81-293.08-17.59-20.37-16.17-47.84-13.55-68.76,7.37-20.91,20.91-23.55,48.36-7.38,68.74-30.58,42.4-47.11,88.26-48.24,134.81-1.42,58.19,21.97,114.4,66.06,158.48l2.85,2.7ZM426.64,363.77c11.63-11.64,25.15-14.48,36.46-8.54-7.98,6.64-15.85,13.75-23.54,21.45-7.68,7.68-14.8,15.55-21.45,23.54-5.93-11.3-3.09-24.82,8.54-36.45ZM377.14,553.01c1.38-56.54,28.09-112.39,77.22-161.53,90.4-90.4,203.77-102.12,288.39-32.15-63.34,20.43-176.16,132.64-181.99,138.47-45.43,45.43-84.76,91.67-110.73,130.21-15.3,22.7-23.73,39.32-27.87,51.71-30.25-36.92-46.12-81.19-45.01-126.7Z"/>
                  <rect class="cls-1" x="661.72" y="463.75" width="388.02" height="20.94" transform="translate(-11.26 927.52) rotate(-56.6)"/>
                  <rect class="cls-1" x="736.34" y="530.55" width="386.31" height="20.95" transform="translate(-132.84 708.7) rotate(-39.17)"/>
                  <path class="cls-1" d="M648.69,936.78c0,13.91,3.61,24.2,11.04,31.47,14.13,13.83,38.67,13.33,72.66,12.56,17.12-.36,38.36-.36,55.49,0,7.31.16,14.19.31,20.62.31,23.58,0,41.19-2,52.34-12.92,7.43-7.27,11.04-17.54,11.04-31.42,0-50.55-45.89-85.84-111.59-85.84s-111.59,35.3-111.59,85.84ZM850.16,927.82c-6.29,7.14-13.93,4.82-35.15-5.15-2.55-1.2-5.25-2.45-8-3.69l21.02-27.52c12.12,9.39,19.88,21.78,22.13,36.37ZM770.75,872.23c14.68.96,27.77,3.99,38.97,8.69l-23.07,30.2c-5.09-1.56-10.4-2.78-15.91-3.51v-35.37ZM806.1,941.62c12.7,5.97,27.3,12.8,40.76,10.88-.27.3-.51.55-.68.72-7.88,7.72-29.9,7.24-57.84,6.64-17.41-.38-39-.38-56.4,0-27.33.6-48.99,1.03-57.13-6.29,1.86.23,3.7.39,5.49.39,13.86,0,26.01-6.48,37.21-12.45,12.68-6.76,25.78-13.75,42.77-13.75s32.01,7.36,45.83,13.85ZM749.81,872.23v35.34c-5.53.72-10.7,1.94-15.54,3.5l-23.13-30.27c11.13-4.63,24.12-7.62,38.67-8.57ZM692.76,891.26l21.6,28.27c-2.31,1.19-4.57,2.37-6.71,3.51-16.24,8.65-25.59,13.02-37.66,7.7,1.63-15.96,9.71-29.44,22.77-39.48Z"/>
                  <path class="cls-1" d="M664.83,698.38l-23.34-18.78-27.05,22.41-24.77-1.46-16.56,37.57h0s-.82,1.87-.82,1.87v81.09c0,22.38,27.2,36.84,69.3,36.84s69.31-14.47,69.31-36.84v-81.4l-21.2-41.51-24.86.21ZM623.94,833.23h-20.95v-53.23h20.95v53.23ZM641.59,758.09c-31.28,0-45.81-8.67-48.04-14.39l9.43-21.39,18.47,1.09,20.24-16.76,15.85,12.76,19.4-.16,12.62,24.69c-2.53,5.72-17.09,14.17-47.96,14.17Z"/>
                  <path class="cls-1" d="M539.97,795.23l9.18-5.05-10.1-18.35-9.17,5.06c-53.36,29.38-82.75,68.2-82.75,109.32,0,89.44,135.52,159.5,308.53,159.5s308.52-70.06,308.52-159.5c0-31.57-17.26-61.91-49.91-87.73l-8.21-6.5-12.99,16.43,8.21,6.5c27.45,21.71,41.96,46.36,41.96,71.3,0,75.11-131.69,138.56-287.58,138.56s-287.59-63.45-287.59-138.56c0-33.13,25.54-65.44,71.9-90.97Z"/>
                  <path class="cls-1" d="M777.57,748.05l10.46.39.79-20.93-10.46-.39c-11.67-.45-23.65-.52-35.38-.29l-10.47.21.42,20.94,10.46-.2c11.36-.22,22.92-.14,34.18.28Z"/>
                  <path class="cls-1" d="M944.55,746.04l-9.13-27.09-28.79-19.67-24.94,10.35-24.92,5.64-18.07,16.18-24.17,9.84-20.88,26.71-4.7,28.2,13,29.7,24.26,13.2,48.57,28.53,21.88,15.64,26.96,11.05,43.14-7.83,11.51-39.38-14.69-34.82,3.46-39.94-22.49-26.3ZM950.28,868.19l-24.5,4.44-17.97-7.14-13.75-9.83,8.7-51.51-57.08-26.59-6.59,44.82-2.53-1.49-18.29-9.97-7.63-17.43,2.8-16.8,14.15-18.11,22.37-9.11,16.73-14.99,20.5-4.64,16.99-6.88,13.64,9.31,8.18,24.29,19.42,22.7-3.15,36.38,13.83,32.73-5.8,19.81Z"/>
                  <polygon class="cls-1" points="1449.72 883.71 1149 764.14 1149 804.26 1393.39 901.43 748.81 1169.88 106.57 901.46 351 804.27 351 764.15 50.31 883.71 50 918.22 741.6 1207.28 755.96 1207.3 1450 918.24 1449.72 883.71"/>
                </svg></template>
              </bos-button>
              <bos-button @click.prevent="openNewGastroRegistrationUrl" color="ghost" bigicon v-else>{{
                $t('fair.header.action.orderNowGastro')
                }}
                <template #icon><svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
                  <path class="cls-1" d="M425.11,713.69s.04.05.06.07c.03.03.07.06.1.09l1.3,1.23c.16.15.37.2.54.35,3.24,2.62,7.68,4.73,14.55,4.73,12.69,0,33.45-7.12,69.24-31.26,38.53-25.97,84.77-65.3,130.2-110.73,7.14-7.14,173.26-174.19,136.18-215.18-.2-.23-.28-.53-.51-.75l-3.12-3.06c-82.74-82.75-195.72-87.81-293.08-17.59-20.37-16.17-47.84-13.55-68.76,7.37-20.91,20.91-23.55,48.36-7.38,68.74-30.58,42.4-47.11,88.26-48.24,134.81-1.42,58.19,21.97,114.4,66.06,158.48l2.85,2.7ZM426.64,363.77c11.63-11.64,25.15-14.48,36.46-8.54-7.98,6.64-15.85,13.75-23.54,21.45-7.68,7.68-14.8,15.55-21.45,23.54-5.93-11.3-3.09-24.82,8.54-36.45ZM377.14,553.01c1.38-56.54,28.09-112.39,77.22-161.53,90.4-90.4,203.77-102.12,288.39-32.15-63.34,20.43-176.16,132.64-181.99,138.47-45.43,45.43-84.76,91.67-110.73,130.21-15.3,22.7-23.73,39.32-27.87,51.71-30.25-36.92-46.12-81.19-45.01-126.7Z"/>
                  <rect class="cls-1" x="661.72" y="463.75" width="388.02" height="20.94" transform="translate(-11.26 927.52) rotate(-56.6)"/>
                  <rect class="cls-1" x="736.34" y="530.55" width="386.31" height="20.95" transform="translate(-132.84 708.7) rotate(-39.17)"/>
                  <path class="cls-1" d="M648.69,936.78c0,13.91,3.61,24.2,11.04,31.47,14.13,13.83,38.67,13.33,72.66,12.56,17.12-.36,38.36-.36,55.49,0,7.31.16,14.19.31,20.62.31,23.58,0,41.19-2,52.34-12.92,7.43-7.27,11.04-17.54,11.04-31.42,0-50.55-45.89-85.84-111.59-85.84s-111.59,35.3-111.59,85.84ZM850.16,927.82c-6.29,7.14-13.93,4.82-35.15-5.15-2.55-1.2-5.25-2.45-8-3.69l21.02-27.52c12.12,9.39,19.88,21.78,22.13,36.37ZM770.75,872.23c14.68.96,27.77,3.99,38.97,8.69l-23.07,30.2c-5.09-1.56-10.4-2.78-15.91-3.51v-35.37ZM806.1,941.62c12.7,5.97,27.3,12.8,40.76,10.88-.27.3-.51.55-.68.72-7.88,7.72-29.9,7.24-57.84,6.64-17.41-.38-39-.38-56.4,0-27.33.6-48.99,1.03-57.13-6.29,1.86.23,3.7.39,5.49.39,13.86,0,26.01-6.48,37.21-12.45,12.68-6.76,25.78-13.75,42.77-13.75s32.01,7.36,45.83,13.85ZM749.81,872.23v35.34c-5.53.72-10.7,1.94-15.54,3.5l-23.13-30.27c11.13-4.63,24.12-7.62,38.67-8.57ZM692.76,891.26l21.6,28.27c-2.31,1.19-4.57,2.37-6.71,3.51-16.24,8.65-25.59,13.02-37.66,7.7,1.63-15.96,9.71-29.44,22.77-39.48Z"/>
                  <path class="cls-1" d="M664.83,698.38l-23.34-18.78-27.05,22.41-24.77-1.46-16.56,37.57h0s-.82,1.87-.82,1.87v81.09c0,22.38,27.2,36.84,69.3,36.84s69.31-14.47,69.31-36.84v-81.4l-21.2-41.51-24.86.21ZM623.94,833.23h-20.95v-53.23h20.95v53.23ZM641.59,758.09c-31.28,0-45.81-8.67-48.04-14.39l9.43-21.39,18.47,1.09,20.24-16.76,15.85,12.76,19.4-.16,12.62,24.69c-2.53,5.72-17.09,14.17-47.96,14.17Z"/>
                  <path class="cls-1" d="M539.97,795.23l9.18-5.05-10.1-18.35-9.17,5.06c-53.36,29.38-82.75,68.2-82.75,109.32,0,89.44,135.52,159.5,308.53,159.5s308.52-70.06,308.52-159.5c0-31.57-17.26-61.91-49.91-87.73l-8.21-6.5-12.99,16.43,8.21,6.5c27.45,21.71,41.96,46.36,41.96,71.3,0,75.11-131.69,138.56-287.58,138.56s-287.59-63.45-287.59-138.56c0-33.13,25.54-65.44,71.9-90.97Z"/>
                  <path class="cls-1" d="M777.57,748.05l10.46.39.79-20.93-10.46-.39c-11.67-.45-23.65-.52-35.38-.29l-10.47.21.42,20.94,10.46-.2c11.36-.22,22.92-.14,34.18.28Z"/>
                  <path class="cls-1" d="M944.55,746.04l-9.13-27.09-28.79-19.67-24.94,10.35-24.92,5.64-18.07,16.18-24.17,9.84-20.88,26.71-4.7,28.2,13,29.7,24.26,13.2,48.57,28.53,21.88,15.64,26.96,11.05,43.14-7.83,11.51-39.38-14.69-34.82,3.46-39.94-22.49-26.3ZM950.28,868.19l-24.5,4.44-17.97-7.14-13.75-9.83,8.7-51.51-57.08-26.59-6.59,44.82-2.53-1.49-18.29-9.97-7.63-17.43,2.8-16.8,14.15-18.11,22.37-9.11,16.73-14.99,20.5-4.64,16.99-6.88,13.64,9.31,8.18,24.29,19.42,22.7-3.15,36.38,13.83,32.73-5.8,19.81Z"/>
                  <polygon class="cls-1" points="1449.72 883.71 1149 764.14 1149 804.26 1393.39 901.43 748.81 1169.88 106.57 901.46 351 804.27 351 764.15 50.31 883.71 50 918.22 741.6 1207.28 755.96 1207.3 1450 918.24 1449.72 883.71"/>
                </svg></template>
              </bos-button>
            </div>
            <fair-documents :title="$t('components.fairDocuments.title')" :documents="documents" v-if="documents && documents.length > 0 && flowState() === 8" />
            <fair-documents :title="$t('components.fairDocuments.title_previous')" mode="past" :documents="pastdocuments" v-if="pastdocuments && pastdocuments.length > 0" />
          </tab>
          <tab
            :name="$t('fair.tabs.tasks.title')"
            :is-disabled="isNewBooth()"
            id="tab-tasks"
          >
            <helper-message
              v-if="booth.hatWarenkorbPositionen && cartPositionsLink"
            >
              <template v-slot:icon>
                <span class="icon-danger">
                  <font-awesome-icon icon="info-circle" />
                </span>
              </template>
              <template v-slot:button>
                <bos-button @click.prevent="openCartPositionsLink">{{
                  $t('fairDetail.cartpositions.action')
                }}</bos-button>
              </template>
              <p>
                {{
                  $t('fairDetail.cartpositions.text')
                    .replace(
                      '{firstname}',
                      ($store.getters['oidcUser'] ? $store.getters['oidcUser'].given_name : '')
                    )
                    .replace(
                      '{lastname}',
                      ($store.getters['oidcUser'] ? $store.getters['oidcUser'].family_name : '')
                    )
                }}
              </p>
            </helper-message>
            <task-listing
              v-if="fair !== undefined && fair.tasks"
              :tasks="fairTasks"
              :booth="$route.params.booth"
              :service-shop-id="serviceShopId"
              :taskLinksAttributes="{
                'fair-id': fair.idCode,
                'location-label': booth[`halleBezeichnung${$store.getters.localeKey}`],
                'booth-label': booth.standnummer
              }"
              :insurance="insurance"
              :startLoadingShopLinks="startLoadingShopLinks"
              :isCoexposant="booth.ausstellerTyp == 'MITAUSSTELLER'"
              :shopLinks="booth.shopzugaenge"
            />
          </tab>
          <tab :name="$t('fair.tabs.costs.title')" :is-disabled="isNewBooth()">
            <cost-listing :booth="booth" />
          </tab>
          <tab :name="$t('fair.tabs.infos.title')" id="tab-info">
            <helper-message v-if="fair.additionalInfo">
              <template v-slot:icon>
                <font-awesome-icon icon="info-circle" />
              </template>
              <p v-html="fair.additionalInfo">
                {{
                  $t('fairDetail.helperMessage.text')
                    .replace(
                      '{firstname}',
                      ($store.getters['oidcUser'] ? $store.getters['oidcUser'].given_name : '')
                    )
                    .replace(
                      '{lastname}',
                      ($store.getters['oidcUser'] ? $store.getters['oidcUser'].family_name : '')
                    )
                }}
                <a @click.prevent="showContactModal">{{
                  $t('fairDetail.helperMessage.action')
                }}</a>
              </p>
            </helper-message>

            <div class="o-grid o-grid--wrap">
              <div
                class="o-grid__cell--width-100"
              >
                <step-listing
                  v-if="fair.steps"
                  :fairName="fair.displayName"
                  :steps="fair.steps"
                />
              </div>
              <div
                class="o-grid__cell--width-100"
              >
                <document-listing
                  v-if="fair.documents"
                  :documents="fair.documents"
                />
              </div>
            </div>

            <helper-message @click="showContactModal" v-if="false">
              <template v-slot:icon>
                <font-awesome-icon icon="question-circle" />
              </template>
              <p>
                {{
                  $t('fairDetail.helperMessage.text')
                    .replace(
                      '{firstname}',
                      $store.getters['oidcUser'].given_name
                    )
                    .replace(
                      '{lastname}',
                      $store.getters['oidcUser'].family_name
                    )
                }}
                <a @click.prevent="showContactModal">{{
                  $t('fairDetail.helperMessage.action')
                }}</a>
              </p>
            </helper-message>
          </tab>
        </tabs>
      </template>

      <router-view v-else :boothId="this.$route.params.booth" />
    </template>
  </div>
</template>

<script>
import { getLocalizationInExcludes, localize } from '@/assets/js/helper'
import { Tabs, Tab } from 'vue-tabs-component'
import BosLoader from '@/components/BosLoader'
import Modal from '@/components/Modal'
import FairHeader from '@/components/FairHeader'
import HelperMessage from '@/components/HelperMessage'
import MarketingTeaser from '@/components/MarketingTeaser'
import TaskListing from '@/components/TaskListing'
import CostListing from '@/components/CostListing'
import DocumentListing from '@/components/DocumentListing'
import StepListing from '@/components/StepListing'
import ApiService from '@/services/ApiService'
import BosButton from '@/components/BosButton'
import { numberFormatter } from '@/assets/js/helper'
import FairDocuments from '@/components/FairDocuments';
import { filter } from 'lodash'


export default {
  name: 'FairDetail',
  data() {
    return {
      initialTabCount: 0,
      cartPositionsLink: null,
      modalId: 'FairContactIframeModal',
      serviceShopId: null,
      startLoadingShopLinks: false,
      teaserLoadedCount: 0,
      checkBoothLater: false
    }
  },
  computed: {
    hasRegistrationLink() {
      return this.getRegistrationLink !== null;
    },
    hasGastroLink() {
      return this.getGastroLink !== null;
    },
    hasDefaultGastroLink() {
      return !!(this.fair.defaultGastroRegistrationUrl)
    },
    getRegistrationLink() {
      if (!this.booth.shopzugaenge) {
        return null;
      }
      let links = this.booth.shopzugaenge.filter(item => item.typ === 'AUSSTAN_ML' && !item.shopId.endsWith('_GASTRO_ML'));
      if (links.length > 0) {
        return links[0];
      }
      return null;
    },
    getGastroLink() {
      if (!this.booth.shopzugaenge) {
        return null;
      }
      let links = this.booth.shopzugaenge.filter(item => item.typ === 'AUSSTAN_ML' && item.shopId.endsWith('_GASTRO_ML'));
      if (links.length > 0) {
        return links[0];
      }
      return null;
    },
    documents() {
      if (this.booth.regiNr && this.fair.documentsstartdate === undefined || this.fair.documentsstartdate === null || new Date(this.fair.documentsstartdate).getTime() < new Date().getTime()) {
        return this.$store.getters['fair/getBoothDocuments'](this.booth.regiNr).data
      }
      return [];
    },
    pastdocuments() {
      if (this.fair._id) {
        return this.$store.getters['fair/getPastBoothDocuments'](this.fair._id).data
      }
      return [];
    },
    isLoading() {
      return this.$store.getters['fair/isLoading']
    },
    fair() {
      let fair = this.$store.getters['fair/getFairByCode'](
        this.$route.params.code
      )

      if ((fair == null || fair._id === undefined) && this.isNewBooth()) {
        fair = this.$store.getters['fair/getOneShopFairByCode'](
          this.$route.params.code
        )
      }

      let locale = 'de'
      if (this.$i18n !== null) {
        //fallback
        locale = this.$i18n.locale
      }
      let inAndExcludes = getLocalizationInExcludes(locale)

      return localize(fair, inAndExcludes.include, inAndExcludes.exclude)
    },
    insurance() {
      this.$store.dispatch('fair/getBoothInsurance', this.$route.params.booth)
      return this.$store.getters['fair/getBoothInsurance'](
        this.$route.params.booth
      )
    },
    booth() {
      if (this.$route.params.booth === 'new') {
        return {}
      }
      let retVal = this.$store.getters['fair/getBooth'](
        this.$route.params.booth
      )
      return retVal
    },
    boothCost() {
      const costs = this.$store.getters['fair/getBoothCost'](
        this.$route.params.booth
      )
      if (costs.data !== undefined) {
        return costs.data
      }
      return []
    },
    boothAddress() {
      return this.$store.getters['fair/getBoothAddress'](
        this.$route.params.booth,
        'x'
      )
    },
    boothCorrespondenceAddress() {
      return this.$store.getters['fair/getBoothCorrespondenceAddress'](
        this.$route.params.booth,
        'x'
      )
    },
    fairTasksDone() {
      return this.fairTasks
        .filter(item => item.isDone === true || item.notificationState === false)
        .map(item => item['_id'])
    },
    fairTasks() {
      const booth = this.booth
      let tasks = []

      if (this.fair.tasks === undefined) {
        return tasks
      }

      this.fair.tasks.forEach(task => {
        let newTask = JSON.parse(JSON.stringify(task))
        if (
          booth.taskNotificationStates !== undefined &&
          booth.taskNotificationStates[newTask._id] !== undefined
        ) {
          newTask.notificationState = booth.taskNotificationStates[newTask._id]
        }

        //filter tasks by boothservices
        let hidden = false
        newTask.boothServices.forEach(boothService => {
          const match = this.boothCost.find(
            item => item.leistungsId == boothService.id
          )
          if (match !== undefined) {
            hidden = boothService.hidden
            newTask.required = boothService.required
          }
        })

        //set task done
        const costs = this.boothCost.filter(
          item => item.leistungsgruppeId === newTask.serviceGroup
        )

        let currentLang = this.$store.getters['ui/getLocale'].substring(0, 2)
        currentLang = currentLang.charAt(0).toUpperCase() + currentLang.slice(1)
        if (costs.length > 0) {
          let dontMarkAsComplete = false
          newTask.costs = []
          costs.forEach(cost => {
            if (cost.dontMarkAsComplete) {
              dontMarkAsComplete = true
            }
            newTask.costs.push({
              article: cost.leistungsId,
              description: cost['leistungsBezeichnung' + currentLang],
              amount:
                cost.einheit === undefined
                  ? cost.menge
                  : `${cost.menge} ${cost.einheit}`,
              cost:
                cost.leistungsgruppeId === 'STAND' || cost.paketTeil
                  ? ''
                  : numberFormatter(cost.einzelPreisNetto),
              total:
                cost.leistungsgruppeId === 'STAND' || cost.paketTeil
                  ? ''
                  : numberFormatter(cost.gesamtPreisNetto)
            })
          })
          if (!dontMarkAsComplete) {
            newTask.isDone = true
          }
        }

        // Fetch deeplink for current task.
        if (!hidden) {
          tasks.push(newTask)
        }
      })
      return tasks
    },
    teamUrl() {
      return `https://aussteller.bernexpo.ch/${this.$store.getters['ui/getLooseLocale']}/portaldata/52/modules/team.aspx?mid=${this.fair.idTeam}`
    }
  },
  methods: {
    openRegistrationUrl() {
      this.clearStepHistory();
      this.openLink(this.getRegistrationLink.shopLinks)
    },
    openNewBoothRegistrationUrl() {
      this.clearStepHistory();
      window.location.href = this.fair.defaultRegistrationUrl
    },
    openNewGastroRegistrationUrl() {
      this.clearStepHistory();
      window.location.href = this.fair.defaultGastroRegistrationUrl
    },
    openGastroRegistrationUrl() {
      this.clearStepHistory();
      this.openLink(this.getGastroLink.shopLinks)
    },
    openLink(shopLinks) {
      this.clearStepHistory();
      let oneclickLink = shopLinks.filter(item => item.ziel == 'ONE_CLICK_ORDER')
      if (oneclickLink.length > 0) {
        window.location.href = oneclickLink[0].href
        return
      }
      let defaultLink = shopLinks.filter(item => item.ziel == 'DEFAULT')
      if (defaultLink.length > 0) {
        window.location.href = defaultLink[0].href
        return
      }
      window.location.href = shopLinks[0].href
    },
    clearStepHistory() {
      const booth = filter(this.$store.state.fair.booths, {
        regiNr: this.$route.params.booth
      })

      let halleBezeichnung = '';
      let standnummer = '';
      if (booth.length > 0) {
        standnummer = booth[0].standnummer
        halleBezeichnung = booth[0].halleBezeichnungDe
        if (this.$store.state.ui.i18n.locale === 'fr-CH') {
          halleBezeichnung = booth[0].halleBezeichnungFr
        }
        if (this.$store.state.ui.i18n.locale === 'en-US') {
          halleBezeichnung = booth[0].halleBezeichnungEn
        }
      }

      ApiService.setCurrentStep(
        this.booth.regiNr,
        '',
        standnummer,
        halleBezeichnung,
        this.$route.params.code
      );
    },
    openRegistrationUrl_OLD() {
      if (this.$route.params.booth !== 'new') {
        console.log(this.booth.shopzugaenge.filter(item => item.typ === 'AUSSTAN_ML'))
        return
        for (let i in this.booth.shopzugaenge) {
          if (this.booth.shopzugaenge[i].typ === 'AUSSTAN_ML') {
            window.location.href = this.booth.shopzugaenge[i].shopLinks[0].href
            break
          }
        }
      } else {
        window.location.href = this.fair.defaultRegistrationUrl
      }
    },
    teaserLoaded() {
      this.teaserLoadedCount++
      if (this.teaserLoadedCount === 2) {
        this.startLoadingShopLinks = true
      }
    },
    isNewBooth() {
      return (
        this.$route.params.booth === 'new' ||
        this.booth.status === 'OP'
        || this.booth.status === 'OFFEN'
      )
    },
    isOP() {
      return this.booth.status === 'OP'
    },
    flowState() {
      if (this.booth === undefined || this.booth === null) {
        return 1
      }
      switch (this.booth.status) {
        case 'BESTELLT':
          return 2
        case 'IN_PRUEFUNG':
          return 4
        case 'BESTAETIGT':
        case 'ZU':
          return 8
        default:
          return 1
      }
    },
    flowText() {
      const overrides = {
        1: this.fair.stateLabelOverrideOpen,
        2: this.fair.stateLabelOverrideOrdered,
        4: this.fair.stateLabelOverrideEvaluation,
        8: this.fair.stateLabelOverrideConfirmed,
      };
      const state = this.flowState();
      if (overrides[state] !== undefined && overrides[state] !== null && overrides[state].trim().length > 0) {
        return overrides[state].trim();
      }
      return this.$t('fairDetail.statusflow.states.' + state);
    },
    getFair() {
      this.$store.dispatch('fair/getBooth', this.$route.params.booth)
      if (!this.isLoading && this.booth.regiNr) {
        this.$store.dispatch('fair/getWithBooths')
        this.$store.dispatch('fair/getOneShopFairs')
        this.$store.dispatch('fair/getBoothDocuments', this.booth.regiNr)
        this.$store.dispatch('fair/getPastBoothDocuments', this.fair._id)
      }
    },
    showContactModal() {
      this.$root.$emit(`modal:${this.modalId}:show`)
    },
    openCartPositionsLink() {
      document.location = this.cartPositionsLink
    },
    getShopLinks() {
      if (this.booth.shopzugaenge !== undefined) {
        this.serviceShopId = this.booth.shopzugaenge[
          this.booth.shopzugaenge.length - 1
        ].shopzugangId.toString()

        var shopFix = this.booth.shopzugaenge.filter((item)=>item.typ === 'SERBUCH');
        if (shopFix.length > 0) {
          this.serviceShopId = shopFix[shopFix.length - 1].shopzugangId.toString();
        }

        console.log('Got shop id: ' + this.serviceShopId)
      }

      if (this.serviceShopId && this.booth.hatWarenkorbPositionen) {
        console.log(this.booth.shopzugaenge)
        let bestellbestandLink = this.booth.shopzugaenge[
          this.booth.shopzugaenge.length - 1
        ].shopLinks.filter(item => item.ziel === 'WARENKROB')

        if (bestellbestandLink.length > 0) {
          this.cartPositionsLink = bestellbestandLink[0].href
        } else {
          this.cartPositionsLink = null
        }
      }
    },
    setInitialTab() {
      let tabsArr = this.$children.filter(
        item => item.activeTabIndex !== undefined
      )
      let tabs = tabsArr.length > 0 ? tabsArr[0] : undefined
      if (tabs === undefined) {
        this.initialTabCount++
        if (this.initialTabCount < 100) {
          window.setTimeout(this.setInitialTab, 100)
        }
        console.log(this.$children)
      } else {
        switch (this.booth.status) {
          case 'BESTELLT':
          case 'IN_PRUEFUNG':
          case 'OFFEN':
          case undefined:
            tabs.selectTab('#tab-statusflow')
            break
          case 'BESTAETIGT':
          case 'ZU':
            tabs.selectTab('#tab-tasks')
            break
          default:
            tabs.selectTab('#tab-info')
            break
        }
      }
    }
  },
  watch: {
    fair() {
      //update preferred fair series
      const userID = this.$store.getters['oidcUser']['sub']
      ApiService.getUser(userID).then(response => {
        if (response.data && response.data.length === 0) {
          ApiService.createUser({
            id: userID,
            preferredFairSeries: this.fair.fairSeries
          })
        } else if (
          response.data[0].preferredFairSeries !== this.fair.fairSeries
        ) {
          response.data[0].preferredFairSeries = this.fair.fairSeries
          ApiService.updateUser(response.data[0])
        }
      })
      if (this.fair._id) {
        this.$store.dispatch('fair/getPastBoothDocuments', this.fair._id)
      }
    },
    $route() {
      this.getFair()
    }
  },
  created() {
    this.getFair()
    if (this.fair._id !== undefined) {
      this.$store.dispatch('fair/getBoothCost', this.$route.params.booth)
      this.$store.dispatch('fair/getBoothAddress', [
        this.$route.params.booth,
        this.booth.vertragsAdresseId
      ])
      this.$store.dispatch('fair/getBoothCorrespondenceAddress', [
        this.$route.params.booth,
        this.booth.korrespondenzAdresseId
      ])
      this.$store.dispatch('fair/getPastBoothDocuments', this.fair._id)

      // Get ServiceShopId.
      this.getShopLinks()
    }
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'fair/setBooth':
          console.log('SET BOOTH!')
          if (this.$route.params.booth !== 'new' && this.booth.regiNr) {
            this.$store.dispatch('fair/getBoothCost', this.$route.params.booth)
            this.$store.dispatch('fair/getBoothDocuments', this.booth.regiNr)
          }

          if (
            this.booth !== null &&
            this.booth !== undefined &&
            JSON.stringify(this.booth) !== JSON.stringify({}) &&
            this.booth.status !== 'OP'
          ) {
            this.$store.dispatch('fair/getBoothAddress', [
              this.$route.params.booth,
              this.booth.vertragsAdresseId
            ])
            if (this.booth.vertragsAdresseId !== undefined) {
              this.$store.dispatch('fair/getBoothCorrespondenceAddress', [
                this.$route.params.booth,
                this.booth.korrespondenzAdresseId
              ])
            }
            this.getShopLinks()
            if (typeof this.booth.status === 'string') {
              this.initialTabCount = 0
              this.setInitialTab()
            }
          } else {
            this.setInitialTab()
          }

          if (this.fair !== undefined && this.fair.booths !== undefined) {
            if (
              this.$route.params.booth !== 'new' &&
              this.fair.booths.filter(
                item => item.standanmeldungId === this.$route.params.booth
              ).length === 0
            ) {
              this.$store.dispatch('setMessage', 'errors.boothNotFound')
              this.$router.push({ name: 'Home' }).catch(err => {})
            }
          } else {
            this.checkBoothLater = true
          }
          break
        case 'fair/setFairs':
          if (
            state.fair.fairs.filter(
              item => item.idCode === this.$route.params.code
            ).length === 0
          ) {
            this.$store.dispatch('setMessage', 'errors.boothNotFound')
            this.$router.push({ name: 'Home' }).catch(err => {})
          } else if (state.fair.booths.length > 0) {
            if (
              this.$route.params.booth !== 'new' &&
              state.fair.booths.filter(
                item =>
                  item.standanmeldungId === this.$route.params.booth ||
                  item.regiNr === this.$route.params.booth
              ).length === 0
            ) {
              this.$store.dispatch('setMessage', 'errors.boothNotFound')
              this.$router.push({ name: 'Home' }).catch(err => {})
            }
          }
          break
      }
      //            console.log('TYPE: ' + mutation.type)
    })
  },
  components: {
    FairDocuments,
    Tabs,
    Tab,
    BosLoader,
    FairHeader,
    HelperMessage,
    MarketingTeaser,
    TaskListing,
    CostListing,
    DocumentListing,
    StepListing,
    Modal,
    BosButton
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td {
  font-size: 1rem;
}

.tabs-component.bos-tabs .tabs-component-tabs {
  &:after {
    border-color: $brand-primary;
  }

  .tabs-component-tab {
    border-color: $brand-primary;

    a {
      color: black;
      font-size: $bos-tabs-font-size;
    }

    &.is-active {
      border-color: $brand-primary;

      a {
        color: $brand-primary;
        font-size: $bos-tabs-font-size;
      }
    }
  }
} 

.o-fair__detail {
  position: relative;

  .header-action {
    position: relative;
    margin-top: 1em;

    &::after {
      content: '.';
      clear: both;
      display: block;
      visibility: hidden;
      height: 0px;
    }

    button {
      float: right;
      position: relative;
      margin-left: 10px;
    }
  }

  hr {
    &.double {
      border-bottom: 1px solid black;
    }
  }

  .tabs-component {
    margin: 0;
  }

  @media print {
    .fair-header {
      display: none;
    }

    .m-helperMessage {
      display: none;
    }

    .o-statusflow {
      display: none;
    }

    .tabs-component {
      margin: 0;

      .tabs-component-tabs {
        display: none;
      }

      .tabs-component-panels {
        margin: 0;
      }
    }

    .o-tasklisting {
      .tasklisting__filter {
        display: none;
      }
    }
  }
}

#tab-info .o-grid .o-grid__cell--first {
  @media (min-width: 48em) {
    padding-right: 20px;
  }
}

#tab-statusflow p {
  margin-bottom: 1rem;
}


</style>
